import React, { useState } from "react";
import { API_URL } from "../../config";
import "./Login.css";

const ResetPassword = () => {
const [{ token, email, environment }] = useState(() => {
  const params = new URLSearchParams(window.location.search);

  return {
    token: params.get("token") || "",
    email: params.get("email") || "",
    environment: params.get("environment") || "production",
  };
});

  const validLink =
    /^[a-f0-9]{64}$/.test(token) &&
    email.length > 0 &&
    ["demo", "production"].includes(environment);

  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const loginUrl =
    `${process.env.PUBLIC_URL || ""}/` +
    (environment === "demo" ? "?demo=true" : "");

  const save = async event => {
    event.preventDefault();
    if (saving || success || !validLink) return;

    setError("");

    if (
      password.length < 10 ||
      new TextEncoder().encode(password).length > 72
    ) {
      setError("Das Passwort benötigt mindestens 10 Zeichen und darf höchstens 72 UTF-8-Bytes enthalten.");
      return;
    }

    if (password !== confirmation) {
      setError("Die Passwörter stimmen nicht überein.");
      return;
    }

    setSaving(true);

    try {
      const endpoint = environment === "demo"
        ? "/api/demo-reset-password"
        : "/api/reset-password";

      const response = await fetch(`${API_URL}${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, token, password }),
      });

      const data = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(data?.error || "Das Passwort konnte nicht geändert werden.");
      }

      setPassword("");
      setConfirmation("");
      setSuccess(true);

      // Token nach erfolgreicher Verwendung aus der URL entfernen.
      window.history.replaceState(
        null,
        "",
        window.location.pathname +
          (environment === "demo" ? "?demo=true" : "")
      );
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="login-page">
      <main className="login-card">
        <h1>Neues Passwort erstellen</h1>

        {!validLink && !success && (
          <p role="alert">
            Der Link ist unvollständig oder ungültig.
            Fordere über „Passwort vergessen“ einen neuen Link an.
          </p>
        )}

        {error && <p role="alert">{error}</p>}

        {success ? (
          <p role="status">
            Dein Passwort wurde geändert. Du kannst dich jetzt anmelden.
          </p>
        ) : validLink && (
          <form className="login-form" onSubmit={save}>
            <div className="login-field">
              <label htmlFor="reset-password">Neues Passwort</label>
              <input
                id="reset-password"
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={event => setPassword(event.target.value)}
                minLength={10}
                maxLength={72}
                disabled={saving}
                required
                aria-describedby="reset-password-hint"
              />
            </div>

            <p id="reset-password-hint">
              Mindestens 10 Zeichen, höchstens 72 UTF-8-Bytes.
              Umlaute benötigen mehr als ein Byte.
            </p>

            <div className="login-field">
              <label htmlFor="reset-confirmation">Passwort wiederholen</label>
              <input
                id="reset-confirmation"
                type="password"
                autoComplete="new-password"
                value={confirmation}
                onChange={event => setConfirmation(event.target.value)}
                minLength={10}
                maxLength={72}
                disabled={saving}
                required
              />
            </div>

            <button
              type="submit"
              className="login-submit-button"
              disabled={saving}
            >
              {saving ? "Wird gespeichert …" : "Passwort ändern"}
            </button>
          </form>
        )}

        <p><a href={loginUrl}>Zur Anmeldung</a></p>
      </main>
    </div>
  );
};

export default ResetPassword;